import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3bfa7468"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "toolbar" }
const _hoisted_2 = { class: "flow-title" }
const _hoisted_3 = {
  class: "btn-toolbar",
  role: "toolbar",
  "aria-label": "Toolbar with button groups"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash fa-fw" }, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = {
  class: "btn-group me-2 ms-5",
  role: "group",
  "aria-label": "Second group"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times-circle fa-fw" }, null, -1))
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Close ")
const _hoisted_9 = [
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = {
  key: 1,
  class: "btn-group",
  role: "group",
  "aria-label": "Third group"
}
const _hoisted_11 = ["disabled"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-save fa-fw" }, null, -1))
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Save ")
const _hoisted_14 = [
  _hoisted_12,
  _hoisted_13
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h5", _hoisted_2, _toDisplayString(_ctx.vm.flow.name), 1),
    _createElementVNode("div", _hoisted_3, [
      (!_ctx.vm.readonly)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            class: _normalizeClass(['btn', 'btn-light', 'me-2', _ctx.vm.readonly || _ctx.vm.selected === null ? 'disabled' : '']),
            title: "Remove objects",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('remove-selected')))
          }, _hoisted_5, 2))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("button", {
          type: "button",
          class: _normalizeClass(['btn', 'btn-light', _ctx.vm.readonly ? 'disabled' : '']),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push({ name: 'automation-flows' })))
        }, _hoisted_9, 2)
      ]),
      (!_ctx.vm.readonly)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("button", {
              type: "button",
              class: _normalizeClass(['btn', 'btn-success', _ctx.vm.readonly || !_ctx.vm.flow.dirty ? 'disabled' : '']),
              disabled: _ctx.vm.readonly || !_ctx.vm.flow.dirty,
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.save()))
            }, _hoisted_14, 10, _hoisted_11)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}